/* eslint-disable prettier/prettier */
import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "registration";

// User Sign-up (ADMIN + EMPLOYER) --> This is integrated in signUp.jsx
// eslint-disable-next-line arrow-parens
export const ownerSignUp = async (_payload) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/owner-signup`;
		const response = await post(endpoint, payload, headers);
		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Invalid Email!") {
				alert("Invalid Email!");
			} else if (message === "Email is already registered!") {
				alert("Email is already registered!");
			} else if (message === "Invalid User Name!") {
				alert("Invalid User Name!");
			} else if (message === "Username is already registered!") {
				alert("Username is already registered!");
			} else if (message === "SSN is already registered!") {
				alert("SSN is already registered!");
			} else if (message === "Owner is already registered!") {
				alert("Owner is already registered!");
			} else if (message === "Owner has not been created yet!") {
				alert("Owner has not been created yet!");
			} else if (message === MESSAGE.none) {
				alert("No Such Data");
			} else if (message === MESSAGE.put.fail) {
				alert("Failed to edit data");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};
